// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
// Date.prototype.Format = function(fmt) { // author: meizz
//   var o = {
//     'M+': this.getMonth() + 1, // 月份
//     'd+': this.getDate(), // 日
//     'h+': this.getHours(), // 小时
//     'm+': this.getMinutes(), // 分
//     's+': this.getSeconds(), // 秒
//     'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
//     'S': this.getMilliseconds() // 毫秒
//   }
//   if (/(y+)/.test(fmt)) {
//     fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
//   }
//   for (var k in o) {
//     if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
//   }
//   return fmt
// }

// export const getDate = (d, format = 'yyyy-MM-dd hh:mm:ss') => {
//   return new Date(d).Format(format)
// }

export const getDate = (d, fmt) => {
  const date = new Date(d)
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

/**
 * 将给定的日期字符串转换为格式化的日期字符串
 *
 * @param {string} dateString - 输入的日期字符串，格式为 'YYYY/MM/DD HH:mm:ss'。
 * @returns {string} 返回格式化后的日期字符串，格式为 'YYYY/MM/DD'。
 */
export function formatDate(dateString) {
  // 将输入的日期字符串转换为 Date 对象
  const date = new Date(dateString)

  // 获取年份、月份和日期
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份是从0开始的，所以加1
  const day = String(date.getDate()).padStart(2, '0') // 保证日期是两位数

  // 返回格式化后的日期字符串，格式为 'YYYY/MM/DD'
  return `${year}/${month}/${day}`
}
/**
 * 日期减去一天
 * @param {*} dateString 'YYYY/MM/DD'
 * @returns 'YYYY/MM/DD'
 */
export function subtractOneDay(dateString) {
  // 将字符串解析为 Date 对象
  const date = new Date(dateString)

  // 减去一天（单位是毫秒）
  date.setDate(date.getDate() - 1)

  // 格式化为 'YYYY/MM/DD'
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从 0 开始，需要 +1
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}/${month}/${day}`
}



// WEBPACK FOOTER //
// ./src/util/Date.js